/* import __COLOCATED_TEMPLATE__ from './qa-assignee.hbs'; */
/* RESPONSIBLE TEAM: team-rd-services */
import templateOnlyComponent from '@ember/component/template-only';
import type AdminSummary from 'embercom/objects/inbox/admin-summary';

interface Signature {
  Args: {
    admin: AdminSummary;
  };
}

const QaAssignee = templateOnlyComponent<Signature>();
export default QaAssignee;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::TableCells::QaAssignee': typeof QaAssignee;
    'inbox2/conversations-table/table-cells/qa-assignee': typeof QaAssignee;
  }
}
